import React from 'react';
import {
	BodyContainer,
	Container
} from '../components/StyledComponents/StyledComponents';
import Navigation from '../components/Navigation/Navigation.jsx';
import AboutDescription from '../components/About/AboutDescription';
import Footer from '../components/Footer/Footer.jsx';
import Button from '../components/Utility/Button';
import { AboutAd } from '../components/AdSense/AdComponents';

const About = () => {
    return (
		<>
			<Navigation page="about" />
			<BodyContainer>
				<AboutDescription />
				<AboutAd />
				<Container flex center>
					<Button
						right
						route="/contact"
						text="Ponte en contacto"
					/>
				</Container>
			</BodyContainer>
			<Footer />
		</>
    );
}

export default About;